import { Outlet } from "react-router";

export function DashboardLayout() {
  return <Outlet />;
}
